import script from "./SALStep3Material.vue?vue&type=script&setup=true&lang=js"
export * from "./SALStep3Material.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__